import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import '../GlobalEduCare/GlobalEduCare.css';
import { Link } from 'react-router-dom';
import './TheSylhetGym.css';
import CarouselForGym from './CarouselForGym/CarouselForGym';
import pixellogo from './logo.png';



const TheSylhetGym = () => {


    return (




        <div>

            <div className='eduCareContainer container'>

                <Grid container spacing={2} className='row align-items-center container forBG'>
                    <section item className='col-md-5'>
                        <section item className='col-md-5'>
                            <div className='text-center'>
                                <img className='responsive my-5' src={pixellogo} alt="" />
                            </div>
                        </section>
                    </section>
                    <section item className='col-md-7'>
                        <div >

                            <div>
                                <Box>


                                    <div class="center-wrap">
                                        <div class="title-container">
                                            <div class="ribbon-left"></div>
                                            <div class="backflag-left"></div>
                                            <div class="title"><a href="https://www.pixelcodebd.com/">Co-Founder and Developer at Pixel Code Tech Solution</a></div>
                                            <div class="backflag-right"></div>
                                            <div class="ribbon-right"></div>
                                        </div>
                                    </div>


                                </Box>
                                <Box>
                                    <p> <strong>Jan 2019 - October 25</strong></p>
                                    <p>
                                        Pixel Code Tech Solution is an online-based start-up that provides customized websites and cross-platform mobile apps. We believe in quality work and innovation. You won't get nothing less than perfect here. Our main goal is to achieve our clients trust and satisfaction through our works.
                                    </p>
                                </Box>
                                <Box>
                                    Visit Us : <Link to="https://www.pixelcodebd.com/" target="blank"> <span className='email'>https://www.pixelcodebd.com/</span> </Link>
                                    <Box className="edu-care-social-media">
                                        <strong>Follow Us On :</strong> <Link to="https://www.facebook.com/pixelCode012" target='blank'> <i class="fab fa-facebook"></i> </Link>  <Link to="https://github.com/Pixel-Code-Tech-Solutions" target='blank'> <i class="fab fa-github"></i> </Link>
                                    </Box>
                                </Box>
                            </div>

                        </div>
                    </section>

                </Grid>

            </div>
            <div>
                <CarouselForGym />
            </div>
        </div>

    );
};

export default TheSylhetGym;